export enum CheckoutState {
  CHECKOUT_STARTED = 'CheckoutStarted',
  VERIFY_PAYMENT_METHOD = 'VerifyPaymentMethod',
  PAYMENT_METHOD_VERIFIED = 'PaymentMethodVerified',
  PAYMENT_TRANSACTION_CREATED = 'PaymentTransactionCreated',
  PAYMENT_TRANSACTION_STARTED = 'PaymentTransactionStarted',
  PAYMENT_TRANSACTION_SUCCEEDED = 'PaymentTransactionSucceeded',
  PAYMENT_TRANSACTION_FAILED = 'PaymentTransactionFailed',
  TICKET_GENERATED = 'TicketGenerated',
  TICKET_SENT = 'TicketSent',
  CHECKOUT_SUCCEEDED = 'CheckoutSucceeded',
  CHECKOUT_FAILED = 'CheckoutFailed'
}
